module.exports = __webpack_public_path__ + "static/media/Step.4c1fd613.png";